import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, NgForm, NgModel } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { AppRoutingModule } from './app-routing.module';
import { JwtModule } from '@auth0/angular-jwt';
import { AppComponent } from './app.component';
import { PagesModule } from './pages/pages.module';

//#region Login
import { LoginComponent } from './login/login.component';
import { PagesComponent } from './pages/pages.component';
import { StorageServiceModule } from 'ngx-webstorage-service';
//#endregion Login

//#region Translate
import { HttpClientModule, HttpClient, HTTP_INTERCEPTORS } from '@angular/common/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { SharedModule } from './shared/shared.module';
import { NotFoundComponent } from './common/not-found/not-found.component';
import { InterceptorService } from '../services/interceptor.service';
import { MailboxComponent } from './mailbox/mailbox.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ResetPassComponent } from './login/reset-pass/reset-pass.component';
import { CurrencyPipe } from '@angular/common';
import { ResetPassFormComponent } from './login/reset-pass-form/reset-pass-form.component';
//#endregion Translate
import { SearchProfileComponent } from './searchProfile/search-profile.component';

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

export function tokenGetter() {
  return '';
}

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    PagesComponent,
    NotFoundComponent,
    MailboxComponent,
    ResetPassComponent,
    ResetPassFormComponent,
    SearchProfileComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    StorageServiceModule,
    FormsModule,
    MatFormFieldModule,
    HttpClientModule,
    // PagesModule, Se comenta para resolver el error de ocultar menus al refrescar
    JwtModule.forRoot({
      config: {
        tokenGetter
      }
    }),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient]
      }
    }),
    SharedModule,
    BrowserAnimationsModule
  ],
  exports: [NgForm, NgModel, MatFormFieldModule],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: InterceptorService,
      multi: true
    },
    CurrencyPipe
   ],
  bootstrap: [AppComponent]
})

export class AppModule { }
